//Copyright (C) 2019 TANNER AG

import React, { useContext, useState } from "react";
import * as PropTypes from "prop-types";
import { Module } from "../module";
import { withStore } from "../../store/withstore";
import { TileButton } from "../../components/button";
import { TranslationContext } from "../../translation";

const ANNUAL_MILEAGES = [40000, 60000, 80000];

export const formatMileages = (mileages, translate, format) => {
	const parsedMileages = parseInt(mileages, 0);
	if (isNaN(parsedMileages)) {
		return "";
	}

	return `${format(parsedMileages)} ${translate("common.km")}`;
};

const AnnualMileage = (props) => {
	const { store: { a }, storeAction } = props;
	const [value, setValue] = useState(a.annualMileage);
	const { translate, format } = useContext(TranslationContext);

	return (
		<Module
			id={props.id}
			activeModule={props.activeModule}
			nextModule={props.nextId}
			onActivate={props.setActiveModule}
			final={props.final}
			label="module.annualmileage.title"
			title="module.annualmileage.query"
			valueA={formatMileages(value, translate, format)}
			valueB={formatMileages(value, translate, format)}
			continueEnabled={value !== null}
			onContinue={() => storeAction.setAnnualMileage(value)}
			queryA={(
				<React.Fragment>
					{ANNUAL_MILEAGES.map((mileages) => (
						<TileButton
							key={mileages}
							onClick={() => setValue(mileages)}
							active={value === mileages}
						>
							{formatMileages(mileages, translate, format)}
						</TileButton>
					))}
				</React.Fragment>
			)}
		/>
	);
};

AnnualMileage.propTypes = {
	id: PropTypes.string.isRequired,
	nextId: PropTypes.string,
	activeModule: PropTypes.string,
	setActiveModule: PropTypes.func
};

export default withStore(AnnualMileage);



// WEBPACK FOOTER //
// ./src/tco/configuration/modules/annualmileage.js